import React, { useContext, useReducer, useEffect } from "react";
import Swal from "sweetalert2";
import OpenReducer from "../reducers/OpenReducer";
import { OPENDATA } from "../api/request";
import * as API from "../api/request";
import { useNavigate } from "react-router-dom";

const OpenContext = React.createContext();

const initialState = {
  tn: 0,
  info: {},
  userdepts: [],
  usergroup: "",
  userGroupList: [],
  usermenu: [],
  userzone: [],
  loggedIn: false,
  header: false,
  menu: [],
  toggle: false,
  selected_menu: null,
};

export const useOpenState = () => {
  const context = useContext(OpenContext);
  if (context === undefined) {
    throw new Error(
      "useOpenState нь OpenContextProvider дотор ашиглагдах ёстой."
    );
  }
  return context;
};

const OpenContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(OpenReducer, initialState);
  const navigate = useNavigate();

  useEffect(() => {
    API.getPublicMenu()
      .then((res) => {
        dispatch({
          type: "SET_PUBLIC_DATA",
          data: { menu: res, selected_menu: res[0].id },
        });
      })
      .catch(() => {
        Swal.fire(
          "Анхаар",
          "Жагсаалт татаж чадсангүй түр хүлээнэ үү.",
          "warning"
        );
      });
  }, []);

  const Login = () => {
    try {
      OPENDATA()
        .get(`/auth`)
        .then((res) => {
          const result = res.data;
          let url = result.url;
          if (window.location.hostname === "localhost") {
            if (window.location.port === "3000") {
              url = url.replace(
                "https://opendata.erdenetmc.mn/callback",
                "http://localhost:3000/callback"
              );
            } else {
              url = url.replace(
                "https://opendata.erdenetmc.mn/callback",
                "http://localhost:3100/callback"
              );
            }
          }
          if (window.location.hostname === "172.16.16.6") {
            url = url.replace(
              "https://opendata.erdenetmc.mn/callback",
              "http://172.16.16.6:3100/callback"
            );
          }
          window.location.replace(url);
        });
    } catch (err) {
      Swal.fire("", "Нэвтэрч чадсангүй.", "warning");
    }
  };

  const Logout = () => {
    try {
      API.getLogOut()
        .then((res) => {
          localStorage.clear();
          dispatch({ type: "LOGOUT" });
          navigate("/");
        })
        .catch((err) => {});
    } catch (err) {
      Swal.fire(
        "",
        "Гарах үйлдэл амжилтгүй боллоо дахин оролдоно уу.",
        "warning"
      );
    }
  };

  return (
    <OpenContext.Provider
      value={{
        state,
        dispatch,
        Login,
        Logout,
      }}
    >
      {children}
    </OpenContext.Provider>
  );
};

export default React.memo(OpenContextProvider);
